import { Node, mergeAttributes } from '@tiptap/core';
import { EnforceSingleNodePlugin } from './enforce-single-node.js';
const BRAND_MAIN_EXT_NAME = 'brandDetail';
const BRAND_DESCRIPTION_EXT_NAME = 'brandDetailDescription';
const BRAND_LINK_EXT_NAME = 'brandDetailLink';
export const BrandDetailDescription = Node.create({
    name: BRAND_DESCRIPTION_EXT_NAME,
    group: BRAND_MAIN_EXT_NAME,
    content: 'paragraph*',
    marks: '',
    isolating: true,
    draggable: false,
    addOptions() {
        return {
            tagName: 'mb-brand-detail-description',
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), 0];
    },
});
export const BrandDetailLink = Node.create({
    name: BRAND_LINK_EXT_NAME,
    group: BRAND_MAIN_EXT_NAME,
    content: 'text*',
    marks: '',
    isolating: true,
    draggable: false,
    addOptions() {
        return {
            tagName: 'mb-brand-detail-link',
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), 0];
    },
});
export const BrandDetail = Node.create({
    name: BRAND_MAIN_EXT_NAME,
    group: 'block',
    content: `${BRAND_LINK_EXT_NAME}{1} ${BRAND_DESCRIPTION_EXT_NAME}{1}`,
    atom: true,
    draggable: true,
    addProseMirrorPlugins() {
        return [new EnforceSingleNodePlugin(this.name)];
    },
    addAttributes() {
        return {
            category: {
                default: null,
                renderHTML(attributes) {
                    return { 'data-category': attributes.category };
                },
                parseHTML(element) {
                    return element.getAttribute('category');
                },
            },
        };
    },
    addCommands() {
        return {
            addBrandDetail: () => ({ commands }) => commands.insertContent({
                type: this.name,
                content: [
                    { type: BrandDetailLink.name },
                    {
                        type: BrandDetailDescription.name,
                        content: [{ type: 'paragraph' }],
                    },
                ],
            }),
        };
    },
    addOptions() {
        return {
            tagName: 'mb-brand-detail',
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), 0];
    },
});
const PRODUCT_MAIN_EXT_NAME = 'productDetail';
const PRODUCT_NAME_EXT_NAME = 'productDetailName';
const PRODUCT_DESCRIPTION_EXT_NAME = 'productDetailDescription';
const PRODUCT_LINK_EXT_NAME = 'productDetailLink';
export const ProductDetailDescription = Node.create({
    name: PRODUCT_DESCRIPTION_EXT_NAME,
    group: PRODUCT_MAIN_EXT_NAME,
    content: 'paragraph*',
    marks: '',
    isolating: true,
    draggable: false,
    addOptions() {
        return {
            tagName: 'mb-product-detail-description',
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), 0];
    },
});
export const ProductDetailLink = Node.create({
    name: PRODUCT_LINK_EXT_NAME,
    group: PRODUCT_MAIN_EXT_NAME,
    content: 'text*',
    marks: '',
    isolating: true,
    draggable: false,
    addOptions() {
        return {
            tagName: 'mb-product-detail-link',
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), 0];
    },
});
export const ProductDetail = Node.create({
    name: PRODUCT_MAIN_EXT_NAME,
    group: 'block',
    content: `${PRODUCT_LINK_EXT_NAME}{1} ${PRODUCT_DESCRIPTION_EXT_NAME}{1}`,
    atom: true,
    draggable: true,
    addAttributes() {
        return {
            category: {
                default: null,
                renderHTML(attributes) {
                    return { 'data-category': attributes.category };
                },
                parseHTML(element) {
                    return element.getAttribute('category');
                },
            },
        };
    },
    addProseMirrorPlugins() {
        return [new EnforceSingleNodePlugin(this.name)];
    },
    addCommands() {
        return {
            addProductDetail: () => ({ commands }) => commands.insertContent({
                type: this.name,
                content: [
                    { type: ProductDetailLink.name },
                    {
                        type: ProductDetailDescription.name,
                        content: [{ type: 'paragraph' }],
                    },
                ],
            }),
        };
    },
    addOptions() {
        return {
            tagName: 'mb-product-detail',
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), 0];
    },
});
//# sourceMappingURL=brand-product-detail.js.map